class ContactDetails extends HTMLElement {
  connectedCallback () {
    this.needCheckbox = this.getAttribute('data-need-checkbox')
    this.hideOrderNumber = this.getAttribute('data-hide-order-number')
    this.photosOnly = this.getAttribute('data-photos-only')
    this.nameLabel = this.getAttribute('data-name-label')
    this.emailLabel = this.getAttribute('data-email-label')
    this.textAreaLabel = this.getAttribute('data-text_Area-label')
    this.orderLabel = this.getAttribute('data-order-label')
    this.inputRequired = this.getAttribute('data-validation-required')
    this.inputValidEmail = this.getAttribute('data-validation-email')
    this.btnSend = this.getAttribute('data-btn-send')
    this.checkboxLabel = this.getAttribute('data-checkbox-label')
    this.dataAttachmentLimit = this.getAttribute('data-attachment-limit')
    this.attachPhotos = this.getAttribute('data-attach-photos')
    this.attachFiles = this.getAttribute('data-attach-files')
    this.captchaError = this.getAttribute('data-recaptcha-error')
    this.toastMessageFileLimit = this.getAttribute(
      'data-toast-file-limit-error',
    )
    this.toastMessageFileSizeLimit = this.getAttribute(
      'data-toast-file-size-limit-error',
    )
    this.fileUploadFailed = this.getAttribute('data-upload-failed-error')
    this.dataUploadedLabel = this.getAttribute('data-done')
    this.dataProgressLabel = this.getAttribute('data-progress')
    this.render()

    this.recaptchaCallback = function () {
      this.captchaId = window.grecaptcha.render('gorgias_recaptcha', {
        sitekey: '6LdfvrUpAAAAAJDyeRVp2x6zX-X0xqYdmbDvNnuf',
      })
    }
    if (window.grecaptcha) {
      this.recaptchaCallback()
    } else {
      const script = document.createElement('script')
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
      script.onload = setTimeout.bind(null, this.recaptchaCallback, 2000)
      document.head.appendChild(script)
    }

    this.attachListeners()
    this._validateInputs()
  }

  render () {
    const checkBoxHtml = `<div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth frm-Custom_Checkbox">
            <input type="checkbox" name="contact-details-check" id="contact-details-check" class="frm-Contact_Checkbox" />
            <label class="frm-Contact_Label" for="contact-details-check">${this.checkboxLabel}</label>
        </div>`
    this.innerHTML = `
                    ${this.needCheckbox ? checkBoxHtml : ''}
                    <div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth">
                        <input type="text" name="name" id="contact-details-name" class="frm-Form_Input" data-required />
                        <label class="frm-Contact_Label" for="contact-details-name">${
                          this.nameLabel
                        }</label>
                        <div class="frm-Contact-Error_Input">${
                          this.inputRequired
                        }</div>
                    </div>
                    <div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth">
                        <input type="email" name="email" id="contact-details-email" class="frm-Form_Input" data-required />
                        <label class="frm-Contact_Label" for="contact-details-email">${
                          this.emailLabel
                        }</label>
                        <div class="frm-Contact-Error_Input">${
                          this.inputValidEmail
                        }</div>
                    </div>
                    <div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth frm-Contact_NotRequired">
                        <input type="text" name="order" id="contact-details-order" class="frm-Form_Input">
                        <label class="frm-Contact_Label" for="contact-details-order">${
                          this.orderLabel
                        }</label>
                        <div class="frm-Contact-Error_Input"></div>
                    </div>
                    <div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth">
                        <textarea name="message" id="contact-details-message" cols="30" rows="10" data-required class="frm-Form_Textarea"></textarea>
                        <label class="frm-Contact_Label" for="contact-details-message">${
                          this.textAreaLabel
                        }</label>
                        <div class="frm-Contact-Error_Input">${
                          this.inputRequired
                        }</div>
                    </div>

                    <file-upload class="frm-Contact_Group fiu-Attachment" data-progress="${
                      this.dataProgressLabel
                    }"data-done="${
      this.dataUploadedLabel
    }" data-upload-failed-error="${
      this.fileUploadFailed
    }" data-toast-file-limit-error="${
      this.toastMessageFileLimit
    }" data-toast-file-size-limit-error="${
      this.toastMessageFileSizeLimit
    }" data-attach-photos="${this.attachPhotos}" data-attach-files="${
      this.attachFiles
    }" data-attachment-limit="${
      this.dataAttachmentLimit
    }" data-accept=".jpeg, .jpg, .png, .pdf , .docx , .xls" ${
      this.photosOnly ? 'data-photos-only="true"' : ''
    }></file-upload> 
                    <div class="frm-Contact_Captcha">
                      <div id="gorgias_recaptcha"></div>
                      <div class="frm-Contact-Error_Input">
                        <p>${this.captchaError}</p>
                      </div>
                    </div>

                    <div class="frm-Contact_Group">
                        <button type="submit" class="frm-Form_Field-fullWidth btn-Button btn-Button-primary btn-mt_30">${
                          this.btnSend
                        } <div class="fiu-Attachment_Spinner"></div></button>
                    </div>`
    this.classList.toggle('is-Active', !this.needCheckbox)
    const checkboxElem = this.querySelector('#contact-details-check')
    checkboxElem &&
      checkboxElem.addEventListener('change', e => {
        this.classList.toggle('is-Active', e.target.checked)
      })
    this.querySelector('#contact-details-order')
      .closest('.frm-Contact_Group')
      .classList.toggle('is-Hidden', this.hideOrderNumber)
  }

  attachListeners () {
    this.querySelectorAll('input,textarea').forEach(input => {
      input.addEventListener('focus', () => {
        input.parentElement.classList.add('is-Focused')
      })
      input.addEventListener('blur', () => {
        input.parentElement.classList.toggle('is-Focused', input.value)
      })
    })
  }

  _validateInputs () {
    this.querySelectorAll('input,textarea').forEach(input => {
      input.addEventListener('input', () => {
        if (input.name !== 'email') {
          return input.parentElement.classList.toggle(
            'frm-Contact-Error',
            !input.value,
          )
        }
        input.parentElement.classList.toggle(
          'frm-Contact-Error',
          !this._validateEmail(input.value),
        )
      })
    })
  }

  _validateEmail (email) {
    return /\S+@\S+\.\S+/.test(email)
  }
}

window.customElements.define('contact-details', ContactDetails)

class ContactFormResult extends HTMLElement {
  connectedCallback () {
    if (!this.hasAttribute('data-result')) return
    this.result = JSON.parse(this.getAttribute('data-result'))
    this.nameLabel = this.getAttribute('data-name-label')
    this.emailLabel = this.getAttribute('data-email-label')
    this.textAreaLabel = this.getAttribute('data-text_Area-label')
    this.inputRequired = this.getAttribute('data-validation-required')
    this.inputValidEmail = this.getAttribute('data-validation-email')
    this.btnSend = this.getAttribute('data-btn-send')
    this.orderLabel = this.getAttribute('data-order-label')
    this.checkboxLabel = this.getAttribute('data-checkbox-label')
    this.attachFiles = this.getAttribute('data-attach-files')
    this.attachPhotos = this.getAttribute('data-attach-photos')
    this.captchaError = this.getAttribute('data-recaptcha-error')
    this.toastMessageFileLimit = this.getAttribute(
      'data-toast-file-limit-error',
    )
    this.toastMessageFileSizeLimit = this.getAttribute(
      'data-toast-file-size-limit-error',
    )
    this.fileUploadFailed = this.getAttribute('data-upload-failed-error')
    this.dataUploadedLabel = this.getAttribute('data-done')
    this.dataProgressLabel = this.getAttribute('data-progress')

    this.render()
  }

  render () {
    if (this.result.content) {
      this.renderContent(this.result.content)
    }
    if (this.result.cta) {
      this.renderCTA(this.result.cta)
    }
    if (this.result.contactFields) {
      this.renderContactFields(this.result.contactFields)
    }
  }

  renderContent (content) {
    const container = document.createElement('div')
    container.classList.add('frm-Contact_Content')
    container.textContent = content.text
    if (content.isBold) container.style.fontWeight = 'bold'
    this.appendChild(container)
  }

  renderCTA (cta) {
    const container = document.createElement('a')
    container.classList.add(
      'btn-Button-primary',
      'btn-Button',
      'frm-Form_Field-fullWidth',
      'frm-Form_Field',
    )

    container.href = cta.link
    container.target = '_blank'

    const link = document.createElement('a')
    link.textContent = cta.text
    link.href = cta.link

    link.target = '_blank'

    link.classList.add('frm-Contact_Link')
    container.appendChild(link)
    this.appendChild(container)
  }

  renderContactFields (contactFields) {
    const contactDetails = document.createElement('contact-details')
    contactDetails.setAttribute('data-name-label', this.nameLabel)
    contactDetails.setAttribute('data-email-label', this.emailLabel)
    contactDetails.setAttribute('data-checkbox-label', this.checkboxLabel)
    contactDetails.setAttribute('data-text_Area-label', this.textAreaLabel)
    contactDetails.setAttribute('data-validation-required', this.inputRequired)
    contactDetails.setAttribute('data-validation-email', this.inputValidEmail)
    contactDetails.setAttribute('data-order-label', this.orderLabel)
    contactDetails.setAttribute('data-btn-send', this.btnSend)
    contactDetails.setAttribute('data-attach-photos', this.attachPhotos)
    contactDetails.setAttribute('data-attach-files', this.attachFiles)
    contactDetails.setAttribute('data-recaptcha-error', this.captchaError)
    contactDetails.setAttribute(
      'data-attachment-limit',
      this.getAttribute('data-attachment-limit'),
    )
    contactDetails.setAttribute('data-done', this.dataUploadedLabel)
    contactDetails.setAttribute('data-progress', this.dataProgressLabel)
    contactDetails.setAttribute(
      'data-toast-file-limit-error',
      this.toastMessageFileLimit,
    )
    contactDetails.setAttribute(
      'data-toast-file-size-limit-error',
      this.toastMessageFileSizeLimit,
    )

    contactDetails.setAttribute(
      'data-upload-failed-error',
      this.fileUploadFailed,
    )

    contactFields.needCheckbox &&
      contactDetails.setAttribute(
        'data-need-checkbox',
        contactFields.needCheckbox,
      )
    contactFields.hideOrderNumber &&
      contactDetails.setAttribute(
        'data-hide-order-number',
        contactFields.hideOrderNumber,
      )
    contactFields.photosOnly &&
      contactDetails.setAttribute('data-photos-only', contactFields.photosOnly)
    this.appendChild(contactDetails)
  }
}
window.customElements.define('contact-form-result', ContactFormResult)

class ContactForm extends HTMLElement {
  connectedCallback () {
    this.form = this.querySelector('form')

    const requiredAttributes = [
      'data-f-01-label',
      'data-f-01-label-done',
      'data-f-01-options',
      'data-f-02-label',
      'data-f-02-options',
      'data-f-03-label',
      'data-f-03-options',
      'data-f-01-name',
      'data-f-02-name',
      'data-f-03-name',
      'data-name-label',
      'data-email-label',
      'data-order-label',
      'data-text_Area-label',
      'data-validation-required',
      'data-validation-email',
      'data-btn-send',
      'data-btn-start-return',
      'data-faulty-not-purchased-in-year_from_store',
      'data-return-not-from-store',
      'data-return-from-store',
      'data-checkbox-label',
      'data-track-order-btn',
      'data-track-order-label',
      'data-attachment-limit',
      'data-recieved-message',
      'data-recieved-subMessage',
      'data-btn-back-to-home',
      'data-attach-photos',
      'data-attach-files',
      'data-recaptcha-error',
      'data-toast-file-limit-error',
      'data-toast-file-size-limit-error',
      'data-upload-failed-error',
      'data-first-selector-require-label',
      'data-done',
      'data-progress',
      'data-recaptcha-server-warning',
      'data-recaptcha-toast-message',
    ]

    if (!this.checkRequiredAttributes(requiredAttributes)) return
    this.renderSelectField(
      this.getAttribute('data-f-01-label'),
      this.getAttribute('data-f-01-options').split('|'),
      this.getAttribute('data-f-01-name'),
      this.resultSet(),
      this.getAttribute('data-f-01-label-done'),
      this.getAttribute('data-validation-required'),
      this.getAttribute('data-first-selector-require-label'),
    )

    this.attachListeners()
  }

  checkRequiredAttributes (requiredAttributes) {
    return requiredAttributes.every(attribute => this.hasAttribute(attribute))
  }

  renderSelectField (
    label,
    options,
    name,
    resultSet,
    labelDone,
    validationRequired,
    firstSelectorRequireLabel,
  ) {
    const container = document.createElement('div')
    container.classList.add('frm-Contact_Group', 'frm-Contact_Initial')
    container.resultSet = resultSet
    container.innerHTML = `
                    <div class="frm-Contact-Selector_Required">${firstSelectorRequireLabel}</div>
                    <select name="${name}" id="contact-form-${name}" class="frm-Form_Select frm-Form_Field-fullWidth" required>
                        <option value=""></option>
                        ${options
                          .map(
                            (option, index) =>
                              `<option value="${index}">${option}</option>`,
                          )
                          .join('')}
                    </select>
                    <label class="frm-Contact_Label" for="contact-form-${name}">${label}</label>
                    <div class="frm-Contact-Error_Input">${validationRequired ||
                      ''}</div>
                `
    container.querySelector('select').classList.add('frm-Contact_Empty')
    container.querySelector('select').addEventListener('change', e => {
      while (container.nextElementSibling) {
        container.nextElementSibling.remove()
      }

      // if  selected option is empty or not selected add a class in the select field
      e.target.classList.toggle('frm-Contact_Empty', !e.target.value)
      e.target.classList.toggle('frm-Select-Error', !e.target.value)
      this.querySelector('.frm-Contact-Selector_Required').classList.add(
        'is-Show',
      )

      if (labelDone && e.target.value) {
        container.querySelector('label').textContent = labelDone
      } else {
        container.querySelector('label').textContent = label
      }

      const next = container.resultSet[e.target.value].next
      if (next) {
        return this.renderSelectField(
          next.label,
          next.options,
          next.name,
          next,
          next.labelDone,
        )
      }
      const result = container.resultSet[e.target.value].result
      if (result) return this.renderResult(result)
    })
    this.form.appendChild(container)
  }

  renderResult (result) {
    const resultElement = document.createElement('contact-form-result')
    resultElement.setAttribute('data-result', JSON.stringify(result))
    resultElement.setAttribute(
      'data-name-label',
      this.getAttribute('data-name-label'),
    )
    resultElement.setAttribute(
      'data-email-label',
      this.getAttribute('data-email-label'),
    )
    resultElement.setAttribute(
      'data-text_Area-label',
      this.getAttribute('data-text_Area-label'),
    )
    resultElement.setAttribute(
      'data-order-label',
      this.getAttribute('data-order-label'),
    )
    resultElement.setAttribute(
      'data-validation-required',
      this.getAttribute('data-validation-required'),
    )
    resultElement.setAttribute(
      'data-validation-email',
      this.getAttribute('data-validation-email'),
    )
    resultElement.setAttribute(
      'data-btn-send',
      this.getAttribute('data-btn-send'),
    )
    resultElement.setAttribute(
      'data-btn-start-return',
      this.getAttribute('data-btn-start-return'),
    )
    resultElement.setAttribute(
      'data-faulty-not-purchased-in-year_from_store',
      this.getAttribute('data-faulty-not-purchased-in-year_from_store'),
    )
    resultElement.setAttribute(
      'data-return-not-from-store',
      this.getAttribute('data-return-not-from-store'),
    )
    resultElement.setAttribute(
      'data-return-from-store',
      this.getAttribute('data-return-from-store'),
    )
    resultElement.setAttribute(
      'data-checkbox-label',
      this.getAttribute('data-checkbox-label'),
    )
    resultElement.setAttribute(
      'data-track-order-btn',
      this.getAttribute('data-track-order-btn'),
    )
    resultElement.setAttribute(
      'data-track-order-label',
      this.getAttribute('data-track-order-label'),
    )
    resultElement.setAttribute(
      'data-attachment-limit',
      this.getAttribute('data-attachment-limit'),
    )
    resultElement.setAttribute(
      'data-recieved-message',
      this.getAttribute('data-recieved-message'),
    )
    resultElement.setAttribute(
      'data-recieved-subMessage',
      this.getAttribute('data-recieved-subMessage'),
    )
    resultElement.setAttribute(
      'data-btn-back-to-home',
      this.getAttribute('data-btn-back-to-home'),
    )
    resultElement.setAttribute(
      'data-attach-photos',
      this.getAttribute('data-attach-photos'),
    )
    resultElement.setAttribute(
      'data-attach-files',
      this.getAttribute('data-attach-files'),
    )
    resultElement.setAttribute(
      'data-recaptcha-error',
      this.getAttribute('data-recaptcha-error'),
    )
    resultElement.setAttribute(
      'data-toast-file-limit-error',
      this.getAttribute('data-toast-file-limit-error'),
    )
    resultElement.setAttribute('data-done', this.getAttribute('data-done'))
    resultElement.setAttribute(
      'data-progress',
      this.getAttribute('data-progress'),
    )

    resultElement.setAttribute(
      'data-toast-file-size-limit-error',
      this.getAttribute('data-toast-file-size-limit-error'),
    )
    resultElement.setAttribute(
      'data-upload-failed-error',
      this.getAttribute('data-upload-failed-error'),
    )
    resultElement.setAttribute(
      'data-recaptcha-server-warning',
      this.getAttribute('data-recaptcha-server-warning'),
    )

    resultElement.setAttribute(
      'data-sender-email',
      this.getAttribute('data-sender-email'),
    )

    resultElement.setAttribute(
      'data-form-tags',
      this.getAttribute('data-form-tags'),
    )
    resultElement.setAttribute(
      'data-recaptcha-toast-message',
      this.getAttribute('data-recaptcha-toast-message'),
    )

    this.form.appendChild(resultElement)
  }

  resultSet () {
    const QUESTION_2 = this.getAttribute('data-f-02-label')
    const OPTIONS_2 = this.getAttribute('data-f-02-options').split('|')
    const NAME_2 = this.getAttribute('data-f-02-name')
    const QUESTION_3 = this.getAttribute('data-f-03-label')
    const OPTIONS_3 = this.getAttribute('data-f-03-options').split('|')
    const NAME_3 = this.getAttribute('data-f-03-name')
    const FAULTY_FROM_STORE_NOT__PURCHASED_IN_YEAR = this.getAttribute(
      'data-faulty-not-purchased-in-year_from_store',
    )
    const RETURN_NOT_FROM_STORE = this.getAttribute(
      'data-return-not-from-store',
    )
    const RETURN_FROM_STORE = this.getAttribute('data-return-from-store')
    const BTN_START_RETURN = this.getAttribute('data-btn-start-return')
    const TRACK_ORDER_BTN = this.getAttribute('data-track-order-btn')
    const TRACK_ORDER_LABEL = this.getAttribute('data-track-order-label')
    const resultSet = {
      // Faulty
      0: {
        next: {
          label: QUESTION_2,
          options: OPTIONS_2,
          name: NAME_2,
          // Yes
          0: {
            next: {
              label: QUESTION_3,
              options: OPTIONS_3,
              name: NAME_3,
              // Yes
              0: {
                result: {
                  contactFields: {
                    needCheckbox: false,
                    hideOrderNumber: false,
                    photosOnly: true,
                  },
                },
              },
              // No
              1: {
                result: {
                  contactFields: {
                    needCheckbox: false,
                    hideOrderNumber: false,
                    photosOnly: true,
                  },
                },
              },
            },
          },
          // No
          1: {
            next: {
              label: QUESTION_3,
              options: OPTIONS_3,
              name: NAME_3,
              // Yes
              0: {
                result: {
                  contactFields: {
                    needCheckbox: true,
                    photosOnly: true,
                  },
                  content: {
                    text: FAULTY_FROM_STORE_NOT__PURCHASED_IN_YEAR,
                    isBold: true,
                  },
                },
              },
              // No
              1: {
                result: {
                  contactFields: {
                    needCheckbox: false,
                    hideOrderNumber: false,
                    photosOnly: true,
                  },
                },
              },
            },
          },
        },
      },
      // Return
      1: {
        next: {
          label: QUESTION_2,
          options: OPTIONS_2,
          name: NAME_2,
          // Yes
          0: {
            result: {
              content: {
                text: RETURN_FROM_STORE,
                isBold: false,
              },
              cta: {
                text: BTN_START_RETURN,
                link: 'https://returnsportal.co/r/josephjoseph-uk?s=1&lang=',
              },
              contactFields: {
                needCheckbox: true,
                hideOrderNumber: false,
              },
            },
          },
          // No
          1: {
            result: {
              content: {
                text: RETURN_NOT_FROM_STORE,
                isBold: true,
              },
              contactFields: {
                needCheckbox: true,
                hideOrderNumber: false,
              },
            },
          },
        },
      },
      // Where is my order
      2: {
        result: {
          content: {
            text: TRACK_ORDER_LABEL,
            isBold: false,
          },
          cta: {
            text: TRACK_ORDER_BTN,
            link: '/apps/track-your-order',
          },
          contactFields: {
            needCheckbox: true,
            hideOrderNumber: false,
          },
        },
      },
      // Product question
      3: {
        result: {
          contactFields: {
            needCheckbox: false,
            hideOrderNumber: true,
          },
        },
      },
      // Checkout or website issue
      4: {
        result: {
          contactFields: {
            needCheckbox: false,
            hideOrderNumber: true,
          },
        },
      },
      // Other
      5: {
        result: {
          contactFields: {
            needCheckbox: false,
            hideOrderNumber: true,
          },
        },
      },
    }

    // if country is not GB then remove the checkbox and CTA from the contact form

    if (Shopify.country !== 'GB') {
      delete resultSet[1].next[0].result.cta
      resultSet[1].next[0].result.contactFields.needCheckbox = false
    }

    // if shopify.country == 'FR' then update CTA link for track order button
    if (Shopify.country === 'FR') {
      resultSet[2].result.cta.link = '/apps/suivi-de-votre-commande'
    }

    return resultSet
  }

  setLoaderInSubmitButton () {
    // toggle a class in the submit button to show the loader
    const submitBtn = document.querySelector(
      '.frm-Contact_Group button[type="submit"]',
    )
    submitBtn.classList.add('is-Uploading')
    submitBtn.disabled = true
  }

  removeLoaderInSubmitButton () {
    const submitBtn = document.querySelector(
      '.frm-Contact_Group button[type="submit"]',
    )
    submitBtn.classList.remove('is-Uploading')
    submitBtn.disabled = false
  }

  toastMessage (message) {
    window
      .Toastify({
        text: message,
        duration: 3000, // umtill the user close the toast
        close: true,
        gravity: 'top', // `top` or `bottom`
        position: 'right', // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: '#fff',
          color: '#494948',
          border: '1px solid #494948',
          fontSize: '12px',
        },
        onClick () {}, // Callback after click
        callback () {}, // Callback after close
      })
      .showToast()
  }

  attachListeners () {
    this.form.addEventListener('submit', e => {
      e.preventDefault()
      const allInputs = [
        ...this.form.querySelectorAll(
          'input[data-required], textarea[data-required]',
        ),
      ]
      const emptyInputs = allInputs.filter(x => !x.value)

      if (emptyInputs.length) {
        return emptyInputs.forEach(x =>
          x.parentElement.classList.add('frm-Contact-Error'),
        )
      }

      // Captcha Validation
      const token = window.grecaptcha.getResponse(this.captchaId)

      if (!token.length > 0) {
        return this.querySelector('.frm-Contact_Captcha').classList.add(
          'frm-Contact-Error',
        )
      }

      const email = this.form.querySelector('#contact-details-email').value
      const subject = this.form.querySelector('#contact-form-subject')
        .selectedOptions[0].textContent
      const message = this.form.querySelector('#contact-details-message').value
      const order = this.form.querySelector('#contact-details-order').value
      const files = this.form.querySelector('file-upload').uploadedFiles

      this.handleFormSubmit(email, subject, message, order, files, this, token)
    })
  }

  handleFormSubmit (email, subject, message, order, files, contactForm, token) {
    this.setLoaderInSubmitButton()
    this.dataRecaptchaServerWarning = this.getAttribute(
      'data-recaptcha-server-warning',
      1,
    )
    this.dataSenderEmail = this.getAttribute('data-sender-email')
    this.dataTags = this.getAttribute('data-form-tags')
    this.dataRecaptchaToast = this.getAttribute('data-recaptcha-toast-message')

    const payload = {
      captcha: token,
      customer: { email },
      status: 'open',
      channel: 'api',
      from_agent: true,
      messages: [
        {
          channel: 'api',
          from_agent: true,
          sender: { email: this.dataSenderEmail },
          via: 'api',
          source: {
            type: 'api',
          },
          body_text: message,
        },
      ],
      tags: [{ name: 'Ecom-Contact' }],
      via: 'api',
    }

    let tag = []
    if (this.dataTags) {
      tag = this.dataTags.split(',')
      payload.tags = tag.map(tag => {
        return { name: tag }
      })
    }

    if (order) {
      payload.meta = { Order: order }
      // changes on  body html
      payload.messages[0].body_html = `<p>${message}</p><p> Order Number :  ${order}</p>`
      payload.subject = `${subject} #Order: ${order}`
    } else {
      payload.subject = subject
      payload.messages[0].body_html = `<p>${message}</p> `
    }

    // if files than inject attachment object after  messages
    if (files) {
      payload.messages[0].attachments = [
        ...files.map(file => {
          return {
            public: true,
            url: file.url,
            name: file.name,
            size: file.size,
            content_type: file.content_type,
          }
        }),
      ]
    }
    const options = {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'X-Gorgias-Account-Api-Call-Limit': '40',
        'Retry-after': '1',
      },
      body: JSON.stringify(payload),
    }

    // if recaptcha is valid then send the form

    fetch(
      'https://9h5nvun54c.execute-api.eu-west-2.amazonaws.com/prod/tickets',
      options,
    )
      .then(response => {
        if (response.status >= 400) {
          throw new Error(this.dataRecaptchaServerWarning)
        }

        const recievedMsg = contactForm.getAttribute('data-recieved-message')
        const recievedSubMsg = contactForm.getAttribute(
          'data-recieved-subMessage',
        )
        const btnBackToHome = contactForm.getAttribute('data-btn-back-to-home')
        contactForm.innerHTML = `<contact-form-submitted data-recieved-message="${recievedMsg}" data-recieved-subMessage="${recievedSubMsg}" data-btn-back-to-home="${btnBackToHome}"></contact-form-submitted>`
        document.querySelector('.pg-AncillaryNav').scrollIntoView()
      })
      .catch(err => {
        console.error(err)
        this.removeLoaderInSubmitButton()
        window.grecaptcha.reset(this.captchaId)
        return this.toastMessage(this.dataRecaptchaToast)
      })
  }
}
window.customElements.define('contact-form', ContactForm)

class ContactFormSubmitted extends HTMLElement {
  connectedCallback () {
    const recievedMsg = this.getAttribute('data-recieved-message')
    const recievedSubMsg = this.getAttribute('data-recieved-subMessage')
    const btnBackToHome = this.getAttribute('data-btn-back-to-home')
    this.innerHTML = `
    <div class="frm-Contact_Submitted">
       <h1 class="frm-Contact_Header fz-36_46">${recievedMsg}</h1>
       <p class="frm_Contact-subHeader">${recievedSubMsg}</p>
       <a href="/" class="frm_Contact-link">
          <button class="frm-Form_Field-fullWidth btn-Button btn-Button-primary">
            ${btnBackToHome}
          </button>
       </a>
  </div>
    `
  }
}
window.customElements.define('contact-form-submitted', ContactFormSubmitted)

class FileUpload extends HTMLElement {
  connectedCallback () {
    this.accept = this.getAttribute('data-accept')
    this.photosOnly = this.getAttribute('data-photos-only')
    this.selectedFiles = []
    this.uploadedFiles = []
    this.dataAttachmentLimit = this.getAttribute('data-attachment-limit')
    this.attachPhotos = this.getAttribute('data-attach-photos')
    this.attachFiles = this.getAttribute('data-attach-files')
    this.render()
    this.input = this.querySelector('input[type="file"]')
    this.dragArea = this.querySelector('.fiu-Attachment_DragArea')
    this.toastMessageFileLimit = this.getAttribute(
      'data-toast-file-limit-error',
    )
    this.toastMessageFileSizeLimit = this.getAttribute(
      'data-toast-file-size-limit-error',
    )
    this.fileUploadFailed = this.getAttribute('data-upload-failed-error')
    this.attachListeners()
    // show the toast message
  }

  render () {
    const attachmentSvg = `<svg class="attachment-svg" width="20" height="20" viewBox="0 0 20 20" fill="#161616" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 5.62496V14.4416C13.75 16.1833 12.475 17.7333 10.7416 17.9C8.74998 18.0916 7.08331 16.5333 7.08331 14.5833V4.28329C7.08331 3.19163 7.86665 2.19996 8.94998 2.09163C10.2 1.96663 11.25 2.94163 11.25 4.16663V12.9166C11.25 13.375 10.875 13.75 10.4166 13.75C9.95831 13.75 9.58331 13.375 9.58331 12.9166V5.62496C9.58331 5.28329 9.29998 4.99996 8.95831 4.99996C8.61665 4.99996 8.33331 5.28329 8.33331 5.62496V12.8C8.33331 13.8916 9.11665 14.8833 10.2 14.9916C11.45 15.1166 12.5 14.1416 12.5 12.9166V4.30829C12.5 2.56663 11.225 1.01663 9.49165 0.849959C7.50831 0.658292 5.83331 2.21663 5.83331 4.16663V14.3916C5.83331 16.7833 7.58331 18.925 9.96665 19.15C12.7083 19.4 15 17.2666 15 14.5833V5.62496C15 5.28329 14.7166 4.99996 14.375 4.99996C14.0333 4.99996 13.75 5.28329 13.75 5.62496Z"></path></svg>`
    this.innerHTML = `<input type="file" multiple="" ${
      this.accept ? `accept="${this.accept}"` : ''
    } name="contact-details-file" class="is-Hidden" />
          <button class="fiu-Attachment_DragArea" type="button"><span aria-hidden="true">${attachmentSvg}</span><span class="fiu-Attachment_Label">${
      this.photosOnly ? this.attachPhotos : this.attachFiles
    }</span></button>
          <div class="frm-Contact_Group frm-Form_Field frm-Form_Field-fullWidth">
            <p class="fiu-Attachment_Limit">${this.dataAttachmentLimit}</p>
          </div>
          `
  }

  attachListeners () {
    this.dragArea.addEventListener('click', () => this.input.click())
    this.input.addEventListener('change', e => {
      const files = this.input.files
      this.handleFiles(files)
      e.target.value = null
    })
    this.dragArea.addEventListener('dragover', e => {
      e.preventDefault()
    })
    this.dragArea.addEventListener('drop', e => {
      e.preventDefault()
      this.handleFiles(e.dataTransfer.files)
    })
  }

  handleFiles (files) {
    if (this.selectedFiles.length + files.length > 10) {
      this.classList.add('max-limit-error')
      return this.toastMessage(this.toastMessageFileLimit)
    }
    ;[...files].forEach(file => {
      if (this.selectedFiles.includes(file.name)) return
      this.selectedFiles.push(file.name)
      this.renderFile(file)
    })
  }

  renderFile (file) {
    this.dataUploadedLabel = this.getAttribute('data-done')
    this.dataProgressLabel = this.getAttribute('data-progress')
    const tickSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="css-l1yk1j e7n0sy34"><path d="M9.00001 16.1701L5.53001 12.7001C5.14002 12.3101 4.51001 12.3101 4.12001 12.7001C3.73001 13.0901 3.73001 13.7201 4.12001 14.1101L8.30001 18.2901C8.69001 18.6801 9.32001 18.6801 9.71001 18.2901L20.29 7.71007C20.68 7.32007 20.68 6.69007 20.29 6.30007C19.9 5.91007 19.27 5.91007 18.88 6.30007L9.00001 16.1701Z" fill="inherit"></path></svg>`

    const closeSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="css-hsxhl8 e7n0sy35"><path d="M18.3 5.70997C17.91 5.31997 17.28 5.31997 16.89 5.70997L12 10.59L7.11 5.69997C6.72 5.30997 6.09 5.30997 5.7 5.69997C5.31 6.08997 5.31 6.71997 5.7 7.10997L10.59 12L5.7 16.89C5.31 17.28 5.31 17.91 5.7 18.3C6.09 18.69 6.72 18.69 7.11 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z" fill="#6A6A6A"></path></svg>`
    const fileListItem = document.createElement('div')
    fileListItem.classList.add('fiu-Attachment_FileList')
    const _1MegaByte = 1 << 20
    const sizeLimitExceeded = file.size > 20 * _1MegaByte

    if (sizeLimitExceeded) {
      this.toastMessage(this.toastMessageFileSizeLimit)
      return 0
    }
    fileListItem.classList.toggle('size-limit-error', sizeLimitExceeded)
    fileListItem.innerHTML = `
          <div class="fiu-Attachment_Name">${file.name}</div>
          <div class="fiu-Attachment_Spinner"></div>
          <div class="fiu-Attachment-Icon_Success" aria-hidden="true">${tickSvg}</div>
          <div class="fiu-Attachment_Progress">
              <div class="fiu-Attachment_Progressing" data-progress="${this.dataProgressLabel}" data-done="${this.dataUploadedLabel}"></div>
              <div class="fiu-Attachment_ProgressDone"></div>
          </div>
          <button class="fiu-Attachment-Icon_Close">${closeSvg}</button>
      `
    this.appendChild(fileListItem)
    !sizeLimitExceeded && this.handleFileUpload(file, fileListItem)

    fileListItem
      .querySelector('.fiu-Attachment-Icon_Close')
      .addEventListener('click', () => {
        this.selectedFiles = this.selectedFiles.filter(
          fileName => fileName !== file.name,
        )

        this.uploadedFiles = this.uploadedFiles.filter(
          ({ _name }) => _name !== file.name,
        )
        fileListItem.remove()
      })
  }

  async handleFileUpload (file, fileListItem) {
    const progressCount = fileListItem.querySelector(
      '.fiu-Attachment_ProgressDone',
    )
    let progress = 0
    fileListItem.classList.add('is-Uploading')
    const progressInterval = setInterval(() => {
      progress += parseInt(Math.random() * 10)
      if (progress > 99) return clearInterval(progressInterval)
      progressCount.textContent = `${progress}%`
      fileListItem.style.setProperty('--progress', `${progress}%`)
    }, 200)
    const endpoint =
      'https://9h5nvun54c.execute-api.eu-west-2.amazonaws.com/prod/upload'
    const formData = new FormData()
    formData.append('file', file)

    try {
      const response = await fetch(endpoint, { method: 'POST', body: formData })
      const [data] = await response.json()
      fileListItem.classList.remove('is-Uploading')
      fileListItem.classList.add('fiu-Attachment_Uploaded')
      clearInterval(progressInterval)
      progressCount.textContent = '100%'
      fileListItem.style.setProperty('--progress', '100%')
      data._name = file.name
      this.uploadedFiles.push(data)
    } catch (error) {
      fileListItem.classList.remove('is-Uploading')
      fileListItem.classList.add('is-Error')
      clearInterval(progressInterval)
      progressCount.textContent = this.fileUploadFailed
      fileListItem.style.setProperty('--progress', '100%')
    }
  }

  toastMessage (message) {
    window
      .Toastify({
        text: message,
        duration: 3000, // 3 seconds
        close: true,
        gravity: 'top', // `top` or `bottom`
        position: 'right', // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: '#fff',
          color: '#494948',
          border: '1px solid #494948',
          fontSize: '12px',
        },
        onClick: () => {}, // Callback after click
      })
      .showToast()
  }
}
window.customElements.define('file-upload', FileUpload)
